module.exports = __webpack_public_path__ + "static/media/cwobrien-archi.60b51998.png";